import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookiePolicy.css';

const CookiePolicy = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Set page title
    document.title = 'Política de Cookies - Termómetro Emocional';
  }, []);
  
  return (
    <div className="cookie-policy-container">
      <div className="policy-header">
        <h1>Política de Cookies</h1>
      </div>
      
      <div className="policy-intro">
        <p>Esta Política de Cookies explica qué son las cookies, cómo las utilizamos y qué opciones tienes en relación con su uso en Termómetro Emocional.</p>
      </div>
      
      <section className="policy-section">
        <h2>1. ¿Qué son las cookies?</h2>
        <div className="section-content">
          <p>Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo (ordenador, tablet, smartphone) cuando visitas un sitio web. Las cookies se utilizan ampliamente para hacer que los sitios web funcionen de manera más eficiente, así como para proporcionar información a los propietarios del sitio.</p>
        </div>
      </section>
      
      <section className="policy-section">
        <h2>2. Tipos de cookies que utilizamos</h2>
        <div className="section-content">
          <p>En Termómetro Emocional utilizamos los siguientes tipos de cookies:</p>
          
          <div className="cookie-type">
            <h3>Cookies esenciales</h3>
            <p>Estas cookies son necesarias para el funcionamiento básico del sitio web y no pueden ser desactivadas en nuestros sistemas. Suelen establecerse solo en respuesta a acciones realizadas por ti, como establecer tus preferencias de privacidad, iniciar sesión o completar formularios.</p>
            <p>Puedes configurar tu navegador para bloquear estas cookies, pero algunas partes del sitio no funcionarán correctamente.</p>
          </div>
          
          <div className="cookie-type">
            <h3>Cookies analíticas</h3>
            <p>Estas cookies nos permiten contar las visitas y las fuentes de tráfico para medir y mejorar el rendimiento de nuestro sitio. Nos ayudan a saber qué páginas son las más y menos populares y cómo se mueven los visitantes por el sitio.</p>
            <p>Si no permites estas cookies, no sabremos cuándo has visitado nuestro sitio y no podremos monitorizar su rendimiento.</p>
          </div>
          
          <div className="cookie-type">
            <h3>Cookies de marketing</h3>
            <p>Estas cookies pueden ser establecidas a través de nuestro sitio por nuestros socios publicitarios. Pueden ser utilizadas por estas empresas para perfilar tus intereses y mostrarte anuncios relevantes en otros sitios.</p>
            <p>No almacenan directamente información personal, sino que se basan en la identificación única de tu navegador y dispositivo de internet.</p>
          </div>
        </div>
      </section>
      
      <section className="policy-section">
        <h2>3. ¿Cómo gestionamos las cookies?</h2>
        <div className="section-content">
          <p>Al acceder por primera vez a nuestro sitio web, verás un banner de cookies que te permite:</p>
          
          <ul className="cookie-management-list">
            <li>Aceptar todas las cookies.</li>
            <li>Configurar tus preferencias para aceptar o rechazar categorías específicas de cookies.</li>
            <li>Acceder a más información sobre nuestra política de cookies.</li>
          </ul>
          
          <p>Puedes cambiar tus preferencias en cualquier momento a través del enlace de "Configuración de cookies" en el pie de página de nuestro sitio web.</p>
        </div>
      </section>
      
      <section className="policy-section">
        <h2>4. ¿Cómo desactivar las cookies?</h2>
        <div className="section-content">
          <p>Además de utilizar nuestro panel de preferencias de cookies, puedes gestionar las cookies a través de la configuración de tu navegador. Los siguientes enlaces te proporcionan información sobre cómo controlar las cookies en los navegadores más comunes:</p>
          
          <ul className="browser-links">
            <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
            <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
            <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a></li>
            <li><a href="https://support.microsoft.com/es-es/windows/eliminar-y-administrar-cookies-168dab11-0753-043d-7c16-ede5947fc64d" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
          </ul>
          
          <p>Ten en cuenta que restringir las cookies puede afectar a la funcionalidad de nuestro sitio web.</p>
        </div>
      </section>
      
      <section className="policy-section">
        <h2>5. Cookies de terceros</h2>
        <div className="section-content">
          <p>Algunos de nuestros socios pueden establecer cookies en tu dispositivo cuando visitas nuestro sitio web. Estos terceros incluyen servicios de análisis y redes publicitarias. Estas cookies les permiten recopilar información sobre tus actividades en nuestro sitio web y otros sitios para proporcionarte publicidad basada en tus intereses y medir la efectividad de nuestro sitio web.</p>
          <p>No tenemos acceso ni control sobre estas cookies. Esta Política de Cookies cubre el uso de cookies por parte de Termómetro Emocional y no cubre el uso de cookies por parte de terceros.</p>
        </div>
      </section>
      
      <section className="policy-section">
        <h2>6. Actualizaciones de la política</h2>
        <div className="section-content">
          <p>Podemos actualizar esta Política de Cookies periódicamente para reflejar cambios en las cookies que utilizamos o por otros motivos operativos, legales o regulatorios. Te recomendamos que visites esta página regularmente para estar informado sobre el uso de cookies y tecnologías relacionadas.</p>
          <p className="last-update">Última actualización: 14 de abril de 2025</p>
        </div>
      </section>
      
      <section className="policy-section">
        <h2>7. Contacto</h2>
        <div className="section-content">
          <p>Si tienes alguna pregunta sobre nuestra Política de Cookies, por favor, contáctanos a través de nuestra <Link to="/contacto" className="inline-link">página de contacto</Link> o envíanos un correo electrónico a privacy@jpsicologo.com.</p>
        </div>
      </section>
      
      <div className="cookie-settings-button-container">
        <button className="open-cookie-settings-button">
          Cambiar preferencias de cookies
        </button>
      </div>
      
      <div className="back-link-container">
        <Link to="/" className="back-link">
          <span className="back-icon">←</span> Volver al inicio
        </Link>
      </div>
    </div>
  );
};

export default CookiePolicy;
